export const PopoverTail = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="8"
            viewBox="0 0 24 8"
            fill="none"
            style={{ display: 'block' }}
        >
            <path d="m12 8-.422-.845a26.859 26.859 0 0 0-.505-.984A12 12 0 0 0 1.106.011C.845 0 .563 0 0 0h24c-.563 0-.845 0-1.106.011a12 12 0 0 0-9.967 6.16c-.127.229-.253.48-.505.984L12 8Z" />
        </svg>
    );
};
